import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PracticeListService } from '@app/core/services/practice-list.service';

@Directive({
  selector: '[ecpRestrictByLocation]',
  standalone: false,
})
export class RestrictByLocationDirective {
  @Input('ecpRestrictByLocation')
  set restrictByLocation(location) {
    this.practiceListService.getUnrestrictedLocations().subscribe((locs) => {
      const matchingLocs = locs.filter((loc) => loc.indexOf(location) !== -1);
      if (matchingLocs && matchingLocs.length > 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  constructor(
    private practiceListService: PracticeListService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}
}
